export const OFFER_CATEGORIES = [
  'Shopping',
  'Electronics',
  'Fashion',
  'Food',
  'Card Offer',
  'Travel',
  'Others',
];

export const BLOG_CATEGORIES = [
  'Fashion and Beauty',
  'Electronics',
  'Mobile',
  'Home',
  'Food and Health',
  'Others',
];
